module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C283"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "C288"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/06_Preface#page_7"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_The_World__key_locations_visited#page_14"
    }
  }, [_vm._v("The World: key locations visited")])]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_Before_We_Go#page_16"
    }
  }, [_vm._v("Before We Go")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_1__On_a_Trip_to_IKEA#page_19"
    }
  }, [_vm._v("1. On a Trip to IKEA")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_2__Vampire_Hunting#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Vampire Hunting")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_3__Dragon_Slaying#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Dragon Slaying")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_4__Through_Holy_Land#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Through Holy Land")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_5__On_Sacred_Slopes#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. On Sacred Slopes")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_6__Across_Kingdoms#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Across Kingdoms")])]), _vm._v(" "), _c('p', {
    staticClass: "C289"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_7__To_Pitcher_Plant_Paradise#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. To Pitcher Plant Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Acknowledgements#page_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Notes#page_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_Index_of_plants#page_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of plants")])]), _vm._v(" "), _c('p', {
    staticClass: "C288"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Index_of_places#page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of places")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f7f2103","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_CONTENTS.vue
// module id = 66
// module chunks = 0